import { destroyElementNode } from "@/helpers/utils";
import store from "@/store";

export default {
  bind(el, binding, vNode) {
    const isSuspended = store.getters.isUserSuspended;

    if (isSuspended) {
      destroyElementNode(el, vNode);
    }
  },
  update(el, binding, vNode) {
    // react to updates
    const isSuspended = store.getters.isUserSuspended;
    
    if (isSuspended) {
      destroyElementNode(el, vNode);
    }
  },
};
